import React, { useState, useEffect, useMemo } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";

import Navbar from "components/Navbar";
import Sidebar from "components/Sidebar";
import { user } from "localStorage";
import { refreshUserProfile } from "utils/refreshUserProfile";
import notificationService from "services/notificationService";
import { FavouritesContext } from "hooks/FavouritesContext";
import { useFavourites } from "hooks/useFavourites";
import { BreadcrumbContext } from "hooks/BreadcrumbContext";

const Layout = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(isNonMobile);
  const [_user, setCurrentUser] = useState(user);
  const favouritesValue = useFavourites();
  const [breadcrumb, setBreadcrumb] = useState(null);
  const breadcrumbValue = useMemo(() => ({ breadcrumb, setBreadcrumb }), [breadcrumb]);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleStorage = () => setCurrentUser(user());
    window.addEventListener("storage", handleStorage);
    window.addEventListener("user-profile-updated", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("user-profile-updated", handleStorage);
    };
  }, []);

  // Re-syncs the cached profile (role's pages[]/permission[]) on every
  // navigation — see utils/refreshUserProfile.js for why this can't just be
  // "read once at login". Throttled/de-duped there, so this is cheap even on
  // rapid navigation.
  useEffect(() => {
    refreshUserProfile();
  }, [pathname]);

  useEffect(() => {
    notificationService.connectAsAdmin();
    return () => notificationService.disconnect();
  }, []);

  return (
    <FavouritesContext.Provider value={favouritesValue}>
      <BreadcrumbContext.Provider value={breadcrumbValue}>
        <Box display="flex" width="100%" height="100vh" overflow="hidden">
          <Sidebar
            user={_user || {}}
            isNonMobile={isNonMobile}
            drawerWidth="270px"
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
          <Box flexGrow={1} display="flex" flexDirection="column" height="100vh" overflow="hidden">
            <Navbar
              user={_user || {}}
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
              breadcrumb={breadcrumb}
            />
            <Box id="main-scroll-container" flexGrow={1} overflow="auto">
              <Outlet />
            </Box>
          </Box>
        </Box>
      </BreadcrumbContext.Provider>
    </FavouritesContext.Provider>
  );
};

export default Layout;
